import { useState } from "react";
import { Plus, Users, Send, Mail } from "lucide-react";
import { C, Panel, Table, Td, Chip, StatusChip, Serif, Label } from "./ui";
import { SEGMENTS, CAMPAIGNS } from "./adminData";

export default function Communications() {
  const [tab, setTab] = useState("campaigns");
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 14 }}>
        <div>
          <Label>Outbound comms</Label>
          <Serif size={26} style={{ marginTop: 4 }}>Communications</Serif>
        </div>
        <button data-testid="comms-new" style={{ display: "flex", alignItems: "center", gap: 7, padding: "10px 16px", background: C.ink, color: "#fff", border: 0, borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          <Plus size={15} /> New campaign
        </button>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: `${C.amber}14`, borderRadius: 8, fontSize: 12, color: C.ink, marginBottom: 18 }}>
        <Mail size={14} color={C.amber} /> Email channel · <b>PROD_EMAIL_ENABLED = false</b> — sends restricted to allowlist until go-live.
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {[["campaigns", "Campaigns"], ["segments", "Segments"]].map(([id, label]) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`comms-tab-${id}`}
            style={{ padding: "8px 16px", borderRadius: 8, border: `1px solid ${tab === id ? C.navy : "rgba(26,30,36,0.12)"}`, background: tab === id ? C.navy : "#fff", color: tab === id ? "#fff" : C.slate, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
            {label}
          </button>
        ))}
      </div>

      {tab === "campaigns" ? (
        <Table head={["Campaign", "Channel", "Segment", "Recipients", "Delivered", "When", "Status"]}>
          {CAMPAIGNS.map((c, i) => (
            <tr key={i} data-testid={`campaign-row-${i}`}>
              <Td style={{ fontWeight: 600 }}>{c.name}</Td>
              <Td><Chip color={C.navy}>{c.channel}</Chip></Td>
              <Td style={{ color: C.slate, fontSize: 12 }}>{c.segment}</Td>
              <Td style={{ fontFamily: "'JetBrains Mono', monospace" }}>{c.recipients.toLocaleString()}</Td>
              <Td style={{ fontFamily: "'JetBrains Mono', monospace", color: c.delivered ? C.green : C.slate }}>{c.delivered ? c.delivered.toLocaleString() : "—"}</Td>
              <Td style={{ color: C.slate, fontSize: 12 }}>{c.date}</Td>
              <Td><StatusChip status={c.status} /></Td>
            </tr>
          ))}
        </Table>
      ) : (
        <div>
          {SEGMENTS.map((s, i) => (
            <Panel key={i} style={{ marginBottom: 10, display: "flex", alignItems: "center", gap: 14 }} data-testid={`segment-row-${i}`}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: `${C.red}12`, display: "flex", alignItems: "center", justifyContent: "center" }}><Users size={19} color={C.red} /></div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: C.ink }}>{s.name}</div>
                <div style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace", marginTop: 2 }}>{s.filter}</div>
              </div>
              <Chip color={s.type === "Dynamic" ? C.green : C.slate}>{s.type}</Chip>
              <div style={{ textAlign: "right", minWidth: 70 }}>
                <div style={{ fontSize: 20, fontWeight: 700, fontFamily: "'JetBrains Mono', monospace" }}>{s.count.toLocaleString()}</div>
                <div style={{ fontSize: 10, color: C.slate, textTransform: "uppercase", letterSpacing: "0.1em" }}>recipients</div>
              </div>
              <button data-testid={`segment-send-${i}`} style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 14px", background: C.ink, color: "#fff", border: 0, borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer" }}><Send size={13} /> Send</button>
            </Panel>
          ))}
          <button data-testid="segment-new" style={{ width: "100%", padding: 13, border: `1.5px dashed rgba(26,30,36,0.2)`, background: "transparent", borderRadius: 10, color: C.slate, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>+ Build a new segment</button>
        </div>
      )}
    </div>
  );
}
